import { FC, lazy } from 'react';
import { Heading } from 'src/components/heading';
import { PageSpinner } from 'src/components/spinner-container';
import { Stack } from 'src/components/stack';
import {
  isRemitReportingSubscriptionInfoLoaded,
  remitReportingSubscriptionInfoLoading,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const PrimaryRemitReportsOverview: FC<{}> = ({}) => {
  const subscriptionInfoRequest = useRemitReportingSubscriptionInfo('PRIMARY');

  if (remitReportingSubscriptionInfoLoading(subscriptionInfoRequest)) {
    return <PageSpinner />;
  }
  if (!isRemitReportingSubscriptionInfoLoaded(subscriptionInfoRequest))
    throw new Forbidden();

  return (
    <Stack gap={2}>
      <Stack flow="column" justifyContent="space-between">
        <Heading mode="title" data-testid="primary-tradings-reporting">
          REMIT Reports
        </Heading>
      </Stack>

      <Page />
    </Stack>
  );
};
